import React from 'react';
import { Box, Typography, Link } from '@mui/material';

const PrivacyPolicy: React.FC = () => (
  <Box sx={{ p: 3, maxWidth: 800, mx: 'auto', mt: 10 }}>
    <Typography variant="h3" gutterBottom>Privacy Policy</Typography>
    <Typography variant="body2" gutterBottom>Last updated: 1 January 2025</Typography>

    <Typography variant="h5" gutterBottom>1. Introduction</Typography>
    <Typography paragraph>Enantio ("we", "us") provides a software-as-a-service and AI web application. This policy explains how we handle personal data under the GDPR and CCPA.</Typography>

    <Typography variant="h5" gutterBottom>2. Data Collected</Typography>
    <Typography component="div">
      <ul>
        <li>Account identifiers such as a generated UUID and the Google <code>sub</code> value when you sign in.</li>
        <li>Billing details processed by Stripe, including name, email and payment method.</li>
        <li>Usage data such as timestamps and message logs needed to operate the service.</li>
        <li>Cookies or similar technologies used for authentication and preferences.</li>
      </ul>
    </Typography>

    <Typography variant="h5" gutterBottom>3. How Data is Used</Typography>
    <Typography component="div">
      <ul>
        <li>Authenticate users and maintain sessions.</li>
        <li>Provide and improve the service.</li>
        <li>Process payments and manage subscriptions.</li>
        <li>Perform analytics and maintain security.</li>
      </ul>
    </Typography>

    <Typography variant="h5" gutterBottom>4. Data Sharing</Typography>
    <Typography paragraph>We share data only with service providers necessary to run Enantio, such as Google for authentication and Stripe for billing. These providers are bound by contractual obligations to safeguard your information.</Typography>

    <Typography variant="h5" gutterBottom>5. Data Retention</Typography>
    <Typography paragraph>Account information is kept while your account is active. Billing records are retained as required for accounting. Message logs and analytics are generally deleted within 30 days. You may request deletion at any time.</Typography>

    <Typography variant="h5" gutterBottom>6. User Rights</Typography>
    <Typography paragraph>You may request access, correction, deletion or a copy of your data. EU residents have rights under the GDPR and California residents under the CCPA, including the right to opt out of sale of personal information (we do not sell personal information). To exercise these rights, contact us at <Link href="mailto:privacy@traitindicator.com">privacy@traitindicator.com</Link>.</Typography>

    <Typography variant="h5" gutterBottom>7. Cookies &amp; Tracking</Typography>
    <Typography paragraph>We use essential cookies for sign-in and security and optional analytics cookies to understand product usage. You can accept or decline non-essential cookies through the banner or your browser settings.</Typography>

    <Typography variant="h5" gutterBottom>8. Contact</Typography>
    <Typography paragraph>If you have questions or requests, email us at <Link href="mailto:privacy@traitindicator.com">privacy@traitindicator.com</Link>.</Typography>

    <Typography variant="h5" gutterBottom>9. Changes to Policy</Typography>
    <Typography paragraph>We may update this policy as our practices evolve. Material changes will be posted on this page.</Typography>
  </Box>
);

export default PrivacyPolicy;
